import React from 'react';

import { Dialog } from '@tencent/spaui';

const FeedBack = (props) => <Dialog {...props}>{props.message}</Dialog>;

export default FeedBack;
